  const milestones = [
    { year: "2015", event: "Company Founded", description: "Started in a small office with 3 team members" },
    { year: "2017", event: "First Major Client", description: "Landed our first Fortune 500 client" },
    { year: "2019", event: "International Expansion", description: "Opened offices in Europe and Asia" },
    { year: "2021", event: "Product Launch", description: "Released our flagship SaaS product" },
    { year: "2023", event: "100 Employees", description: "Grew to a team of 100+ professionals" },
    { year: "2024", event: "200 employees", description: "Grew to a team of 200+ professionals" },
    
  ];
  export default milestones;